import axiosV2, { apiPost } from '../core/http/axios_api_v2';

export default {


    saveComment(comment, customerId, extraData, id) {


        if (extraData.createTask) {

            let task = planup.$handlers.tasksHandler.generateLocalEmptyTask();
            task.description = 'מעקב: \n\n' + comment;
            task.name = 'מעקב: \n\n' + comment;



            planup.$handlers.customerHandler.getCustomer(customerId).then(customer => {

                task.customer = customer;
                planup.$root.$emit('openTaskModal', task)

            })



        }


        return apiPost('tracking-log', { comment, customerId, extraData, id }).then(log => {


            let customerPage = planup.$globals.findComponent('CustomerPage');

            if (customerPage.customerId == customerId) {
                log.value = JSON.parse(log.value);



                if (id) {

                    const index = customerPage.customerLog.findIndex(item => item.id === log.id);
                    log.created = new Date(log.created);
                    customerPage.customerLog.splice(index, 1, log);

                } else {
                    log.created = new Date();
                    customerPage.customerLog.unshift(log);
                }


            }


            return log;

        })

    },


    deleteComment(log, customerId) {


        planup.$swal({
            title: 'האם למחוק את ההערה?',
            showCancelButton: true,
            confirmButtonText: 'כן',
            cancelButtonText: 'לא',
            confirmButtonColor: '#ab8ce4'
        }).then(() => {

            return apiPost(`tracking-log/delete/${log.id}`).then(() => {


                let customerPage = planup.$globals.findComponent('CustomerPage');

                if (customerPage.customerId == customerId) {

                    const index = customerPage.customerLog.findIndex(item => item.id === log.id);
                    customerPage.customerLog.splice(index, 1);
                }

            })

        }).catch(() => { })





    },

    async saveLogWithDocument(log) {
        // hideSuccessAlert on every write here — the caller (customer page log modal)
        // shows one explicit success message; otherwise each api call pops its own toast
        if (log.document && log.document.content) {
            // If document doesn't have an ID, we need to save it
            if (!log.document.id) {
                const savedDocument = await planup.$handlers.documentsHandler.saveDocument(log.document, true);
                log.document.id = savedDocument.id;
            } else {
                // Update existing document
                await planup.$handlers.documentsHandler.saveDocument(log.document, true);
            }
        }

        // Now save the log with the document reference
        // apiPost already resolves with the response body — savedLog IS the log entity
        return apiPost('tracking-log/update', log, true).then(savedLog => {
            // Update the local customer log if we're on the customer page
            let customerPage = planup.$globals.findComponent('CustomerPage');
            if (customerPage && customerPage.customerId == log.customerId) {
                const index = customerPage.customerLog.findIndex(item => item.id === log.id);
                if (index !== -1) {
                    customerPage.customerLog.splice(index, 1, savedLog);
                }
            }
            return savedLog;
        });
    },




    createFreeTextLog(text, customerId) {
        return apiPost('tracking-log', { text, customerId }).then(response => response.data)

    },


    // הערות פנימיות של אירוע (InternalNotesModal). Every answer is { notes: newest first,
    // internalNote: the newest note's text - what the /customers column shows }.
    // A note from before the list has id 'legacy'. No success toast: the list stays open and
    // shows the change, and the toasts piled up over it.

    getInternalNotes(eventId) {
        return axiosV2(`tracking-log/internalNotes/${eventId}`).then(response => response.data);
    },

    addInternalNote(eventId, text) {
        return apiPost(`tracking-log/internalNotes/${eventId}`, { text }, true);
    },

    editInternalNote(eventId, noteId, text) {
        return apiPost(`tracking-log/internalNotes/${eventId}/${noteId}`, { text }, true);
    },

    // asks first - resolves with null when the answer was no
    deleteInternalNote(eventId, noteId) {

        return planup.$swal({
            title: 'האם למחוק את ההערה?',
            showCancelButton: true,
            confirmButtonText: 'כן',
            cancelButtonText: 'לא',
            confirmButtonColor: '#ab8ce4'
        }).then(() => true, () => false).then(confirmed => {

            if (!confirmed)
                return null;

            return apiPost(`tracking-log/internalNotes/${eventId}/${noteId}/delete`, null, true);
        });
    },

    // a line of the customer page log that is an internal note (its pen / trash go to the notes list)
    isInternalNote(log) {
        return !!log && log.table == 'internalNote' && !!log.eventId;
    },


    actionToText(action, table) {

        if (action == 0 && table == 'events')
            return 'פניה חדשה:';

        switch (action) {
            case 0:
                return 'יצירת';
            case 1:
                return 'עריכת';
            case 2:
                return 'הערה';
        }
    },



    getAll() {
        return axiosV2('tracking-log').then(response => response.data)
    },

    getCustomerHistory(customerId, eventId) {
        // return axiosV2(`tracking-log/customerHistory/${customerId}?eventId=${eventId?eventId:''}`).then(response => response.data)
        return axiosV2(`tracking-log/customerHistory/${customerId}`).then(response => response.data)

    },



    printSingleValue(field, value) {


        // null status is still meaningful — it renders as the default "פניה חדשה" chip.
        // Same pill the summary strip and the /customers table draw, so the log matches them.
        if (field === 'planupSystemStatus')
            return planup.$handlers.eventHandler.systemStatusPillHTML(value);


        if (value === null || value === undefined)
            return '';


        switch (field) {


            case 'title':
                //contact title is a role object ({name: "חתן"}), meeting/document title is a string
                return typeof value === 'object' ? (value.name || '') : value;

            case 'leadSources':
                return Array.isArray(value) ? value.map(source => source.name).join(', ') : '';



            case 'terms':
                return value.name || '';

            case 'specificRequestedDates':
                let specificRequestedDatesText = '';
                if (Array.isArray(value))
                    value.map(d => specificRequestedDatesText += planup.$globals.niceDate(d) + ' ')
                return specificRequestedDatesText;

            case 'requestedDateRange':
                return `${value.rangeStart} - ${value.rangeEnd}`

            case 'products':
                return this.printProductsValue(value);

            case 'content':
                return this.printContentValue(value);


            case 'notifyMailAddress':
                let notifyMailAddressText = '';
                if (Array.isArray(value))
                    value.map(email => notifyMailAddressText += `${email.name} ${email.email} `)
                return notifyMailAddressText;

            case 'meetingType':
            case 'place':
            case 'eventClass':
                return value.name || '';
            case 'crewMembers':
            case 'recommendedCrewMembers':
                return Array.isArray(value) ? value.map(member => member.name).join(', ') : '';
            case 'contacts':

                return planup.$globals.concatContactNames({ contacts: value });
            case 'date':
                return planup.$globals.niceDate(value);
            case 'planupMeetingType':
                return value.name || '';

            case 'signHazmanaDate':
                return planup.$globals.niceDate(value);

            //document.eventClassId is a real column (unlike the other relations) so it logs a raw id
            case 'eventClassId':
                return this.nameFromStoreList('eventClasses', value);

            //appointments.meetingStatusId (סטטוס הפגישה) is a plain column too
            case 'meetingStatusId':
                return this.nameFromStoreList('planupMeetingStatuses', value);

            case 'tags':
                return Array.isArray(value) ? value.join(', ') : '';

            case 'attachments':
                return Array.isArray(value) ? value.map(file => file.title).filter(title => title).join(', ') : '';

            case 'selectedMeals':
            case 'selectedBarItems':
                return this.printSelectedMealsValue(value);

            case 'social':
                return this.printSocialValue(value);

            //the customer's type and business kind are stored as keys - print their Hebrew names
            case 'customerType':
                return value == 'business' ? 'עסקי' : 'פרטי';
            case 'businessIdType':
                return (planup.$handlers.customerHandler.businessIdTypeOptions.find(option => option.value == value) || {}).name || '';

            //נוכחים באירוע: 1 / 0, or null = back to the booking settings' default
            case 'presentAtEvent':
                return value === null || value === undefined || value === '' ? 'ברירת מחדל' : (+value ? 'כן' : 'לא');

            //without this a boolean prints as "true"/"false"
            case 'forAllEmployees':
            case 'appearsOnOrder':
            case 'isTemplate':
            case 'hidden':
                return value ? 'כן' : 'לא';

        }


        // never leak raw objects ("[object Object]") into the log
        if (typeof value === 'object')
            return '';

        return value;

    },


    // products is a heavy JSON blob — show just the product names and the total
    printProductsValue(value) {

        if (!Array.isArray(value))
            return '';

        let names = [];
        let total = 0;

        value.map(group => {
            if (group && Array.isArray(group.actualListOfProducts))
                group.actualListOfProducts.map(product => names.push(product.name));
            if (group && group.totalSumAfterVat)
                total += group.totalSumAfterVat;
        });

        if (!names.length)
            return '';

        let text = names.join(', ');

        if (total)
            text += ' (סה"כ ' + (Math.round(total * 100) / 100) + ' ₪)';

        return text;

    },


    // document content is HTML — show a short plain-text preview instead of rendering it
    printContentValue(value) {

        let text = String(value)
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();

        if (text.length > 120)
            text = text.substring(0, 120) + '…';

        return text;

    },


    printSelectedMealsValue(value) {

        if (!Array.isArray(value))
            return '';

        return value
            .map(meal => {
                if (!meal.mealName) return '';
                let text = meal.quantity ? `${meal.mealName} (${meal.quantity})` : meal.mealName;
                // the upgrade options ticked for the meal (אפשרויות שדרוג), with their extra price
                const upgrades = Array.isArray(meal.upgrades) ? meal.upgrades.filter(upgrade => upgrade && upgrade.name) : [];
                if (upgrades.length)
                    text += ` - שדרוג: ${upgrades.map(upgrade => Number(upgrade.price) > 0 ? `${upgrade.name} (תוספת ${upgrade.price} ₪)` : upgrade.name).join(', ')}`;
                if (meal.note) text += ` - הערה: ${meal.note}`;
                return text;
            })
            .filter(name => name)
            .join(', ');

    },


    // {"instagram": "mit4mit", "facebook": "mitformit"}
    printSocialValue(value) {

        if (!value || typeof value !== 'object')
            return '';

        return Object.keys(value)
            .filter(network => value[network])
            .map(network => `${network}: ${value[network]}`)
            .join(', ');

    },


    // an id column logs a bare number — resolve it against the store list so the log reads
    // 'סוג אירוע: ל-"חתונה"' and not 'ל-"3"'. Unknown id (hidden/deleted row) keeps the number
    // rather than returning '' — an empty value would render as "הערך נמחק", which is a lie.
    nameFromStoreList(listName, id) {

        if (!id)
            return '';

        let list = planup.$store.state[listName];

        if (Array.isArray(list)) {
            let match = list.find(item => item.id == id);
            if (match)
                return match.name;
        }

        return String(id);

    },


    escapeHtml(text) {
        return String(text === 0 || text ? text : '')
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },


    isEmptyPrintedValue(value) {
        if (value === null || value === undefined)
            return true;
        return String(value).trim() === '';
    },

    logTableLink(table, value) {



        switch (table) {
            case 'events':
                return `/customer/${value.customerId}?eventId=${value.entityId}`
            case 'customer_contact':
                return 'איש קשר';
            case 'document':
                return 'מסמך';
            case 'appointments':
                return 'פגישה';
            case 'interaction':
                return 'תיעוד שיחה';
            case 'optionalDates':
                return 'תאריכים אופציונליים';
            // the booking page's self-service (a verified phone): a date moved by the customer, the fee charged
            case 'bookingMove':
                return 'שינוי מועד';
            case 'bookingNoShowFee':
                return 'דמי ביטול';
            // the customer's answer on the meeting's own link (planup.co.il/r/...): אישור הגעה / ביטול / מועד אחר
            case 'meetingResponse':
                return 'תשובת הלקוח לפגישה';
        }

        return table;

    },


    fieldToHebrew(field, table) {

        switch (field) {

            case 'title':
                //on a contact, title is the role (חתן/כלה) — not a name
                if (table == 'customer_contact')
                    return 'תפקיד';
                return 'שם';

            case 'place':
                if (table == 'appointments')
                    return 'מקום הפגישה';
                return 'מקום האירוע';

            case 'endTime':
                return 'שעת סיום';

            case 'firstName':
                return 'שם פרטי';
            case 'lastName':
                return 'שם משפחה';
            case 'name':
                return 'שם';
            case 'date':
                return 'תאריך';
            case 'reservePercentage':
                return 'אחוז רזרבה';
            case 'products':
                return 'מוצרים/שרותים';
            case 'crewMembers':
                return 'צוות';
            case 'recommendedCrewMembers':
                return 'הומלץ על';
            case 'notes':
                return 'הערות';
            case 'otherVendors':
                return 'ספקים אחרים';
            case 'terms':
                return 'תנאי הסכם';
            case 'requestedDateRange':
                return 'טווח תאריכים מבוקש';
            case 'specificRequestedDates':
                return 'תאריכים מבוקשים';
            case 'estimatedNumberOfGuests':
                return 'מספר אורחים'
            case 'leadSources':
                return 'מקור הפניה';
            case 'content':
                return 'תוכן';
            case 'planupMeetingType':
                return 'סוג פגישה';
            case 'eventClass':
                return 'סוג אירוע';
            case 'taxDocumentCustomerKey':
                return 'מספר לקוח חשבונאי';
            //סוג לקוח (פרטי / עסקי) and the business fields on the customer row
            case 'customerType':
                return 'סוג לקוח';
            case 'businessName':
                return 'שם העסק';
            case 'businessIdType':
                return 'סוג העסק';
            case 'businessNumber':
                return 'ח.פ. / מספר עוסק';
            case 'businessAddressStreet':
                return 'רחוב (העסק)';
            case 'businessAddressNumber':
                return 'מספר בית (העסק)';
            case 'businessAddressCity':
                return 'עיר (העסק)';
            case 'businessAddressMikud':
                return 'מיקוד (העסק)';
            case 'contacts':
                return 'אנשי קשר';
            case 'email':
                return 'מייל';
            case 'phone':
                return 'טלפון';
            case 'meetingType':
                return 'סוג פגישה'
            case 'notifyMailAddress':
                return 'כתובת מייל'
            case 'teudatZehut':
                return 'תעודת זהות'
            case 'address_street':
                return 'רחוב'
            case 'address_number':
                return 'מספר בית'
            case 'address_city':
                return 'עיר'
            case 'address_mikud':
                return 'מיקוד'
            case 'time':
                return 'שעה';
            case 'comments':
                return 'הערות';
            case 'summary':
                return 'סיכום';
            case 'planupSystemStatus':
                return 'מצב פניה';

            //events
            case 'internalNote':
                return 'הערה פנימית';
            case 'print_notes':
            case 'printNotes':
                return 'הערות להדפסה';
            case 'orderNumber':
                return 'מספר הזמנה';
            case 'finalNumberOfGuests':
                return 'מספר אורחים סופי';
            case 'minimumGuests':
                return 'מינימום אורחים לחיוב';
            case 'optionalDatesHoldUntil':
                return 'שריון התאריכים עד';
            case 'eventDurationDays':
                return 'משך האירוע בימים';
            case 'presentAtEvent':
                return 'נוכחים באירוע (תיאום פגישות)';
            case 'signHazmanaDate':
                return 'תאריך חתימת הזמנה';
            case 'mikdama':
                return 'מקדמה';
            case 'mikdamaPaymentType':
                return 'אופן תשלום מקדמה';
            case 'mealCost':
                return 'עלות מנה';
            case 'selectedMeals':
                return 'מנות';
            case 'selectedBarItems':
                return 'תפריט בר';

            //appointments
            case 'contactPhone':
                return 'טלפון ליצירת קשר';
            case 'location':
                return 'מיקום';
            case 'referrer':
                return 'מפנה';
            case 'numOfGuests':
                return 'מספר אורחים';
            case 'monthOfIntrest':
                return 'חודש מבוקש';
            case 'forAllEmployees':
                return 'לכל העובדים';
            case 'attachments':
                return 'קבצים מצורפים';
            case 'hidden':
                return 'מוסתר';

            //customer_contact
            case 'comment':
                return 'הערה';
            case 'social':
                return 'רשתות חברתיות';
            case 'appearsOnOrder':
                return 'מופיע בהזמנה';

            //customer
            case 'leadOrigin':
                return 'מקור הפניה';

            //appointments
            case 'meetingStatusId':
                return 'סטטוס הפגישה';

            //document
            case 'eventClassId':
                return 'סוג אירוע';
            case 'tags':
                return 'תגיות';
            case 'isTemplate':
                return 'תבנית';

        }

        return field;

    },











    formatValueForEdit(table, value) {

        let lines = [];
        let customFieldsTouched = false;


        for (let i = 0; i < value.length; i++) {

            let field = value[i].field;

            if (this.fieldsToSkip.includes(field))
                continue;

            // custom field storage columns — raw ids/objects are meaningless to the user
            if (this.isCustomFieldStorageField(field)) {
                customFieldsTouched = true;
                continue;
            }

            let from = this.printSingleValue(field, value[i].from);
            let to = this.printSingleValue(field, value[i].to);

            let fromEmpty = this.isEmptyPrintedValue(from);
            let toEmpty = this.isEmptyPrintedValue(to);

            // nothing on either side — no information to show
            if (fromEmpty && toEmpty)
                continue;

            // no visible change (e.g. JSON column rewritten with same content)
            if (!fromEmpty && !toEmpty && String(from) === String(to))
                continue;

            let label = this.fieldToHebrew(field, table);

            // a chip value is HTML with its own frame — quoting it leaves stray marks around the pill
            let q = this.isChipField(field) ? '' : '"';

            if (toEmpty)
                lines.push(`${label}: הערך נמחק`);
            else if (fromEmpty || value[i].dontShowFrom)
                lines.push(`${label}: ל-${q}${to}${q}`);
            else
                lines.push(`${label}: מ-${q}${from}${q} ל-${q}${to}${q}`);

        }


        if (customFieldsTouched)
            lines.push('עדכון שדות מותאמים אישית');


        return lines.join('<br>');

    },


    isCustomFieldStorageField(field) {
        return field === 'customFields' || /^entity_ref_slot_\d+$/.test(field);
    },


    // printed as a pill instead of plain text (see printSingleValue)
    isChipField(field) {
        return field === 'planupSystemStatus';
    },


    formatValue(action, table, value, log) {



        if (action == 2) {//if is comment

            // typed text (internal notes, comments) going into v-html - escaped, its line breaks kept
            if (value && value.comment) {

                let html = this.escapeHtml(value.comment).replace(/\n/g, '<br>');

                // an internal note from before they became a list: its date is the day it joined the list
                if (value.legacy)
                    html += '<div style="font-size:13px;color:#999">הערה קודמת</div>';

                return html;
            }

            //comment rows with no text are usually an attached document (e.g. meeting summary)
            if (log && log.document)
                return `צורף מסמך${log.document.name ? `: "${log.document.name}"` : ''}`;

            return '';
        }






        if (action) {//if is edit
            return this.formatValueForEdit(table, value);
        }


        //here we know the log is of creation of an object
        let formatted = '';

        let fields = Object.keys(value);

        for (let i = 0; i < fields.length; i++) {


            let field = fields[i];

            if (value[field] === null)
                continue;


            if (value[field].length == 0)
                continue;

            if (!Object.keys(value[field]).length)
                continue;


            if (this.fieldsToSkip.includes(field))
                continue;

            if (this.isCustomFieldStorageField(field))
                continue;

            let printed = this.printSingleValue(field, value[field]);

            if (this.isEmptyPrintedValue(printed))
                continue;

            formatted += `${this.fieldToHebrew(field, table)}: ${printed}<br> `

        }

        return formatted;

    },



    logTableToText(action, table) {

        //new event rows already read "פניה חדשה:" from actionToText — don't add "אירוע" after it
        if (table == 'events' && action == 0)
            return;

        return this.logTableToTextPlain(table);
    },


    logTableToTextPlain(table) {

        switch (table) {
            case 'events':
                return 'אירוע'
            case 'customer':
                return 'לקוח';
            case 'customer_contact':
                return 'איש קשר';
            case 'document':
                return 'מסמך';
            case 'appointments':
                return 'פגישה';
            case 'interaction':
                return 'תיעוד שיחה';
            case 'optionalDates':
                return 'תאריכים אופציונליים';
            // the booking page's self-service (a verified phone): a date moved by the customer, the fee charged
            case 'bookingMove':
                return 'שינוי מועד';
            case 'bookingNoShowFee':
                return 'דמי ביטול';
            // the customer's answer on the meeting's own link (planup.co.il/r/...): אישור הגעה / ביטול / מועד אחר
            case 'meetingResponse':
                return 'תשובת הלקוח לפגישה';
            // a comment row (action 2) - reads "הערה פנימית"
            case 'internalNote':
                return 'פנימית';
        }

        return table;
    },


    fieldsToSkip: [
        'event', 'milestones', 'pic', 'errors', 'googleCalendarEventIds', '0', 'id', 'lastEdit', 'created', 'updated', 'customer', 'inGrideMode', 'presetLocked', 'strictTables', 'reservedSeatingAllowed', 'groupName', 'inGridMode',
        'resevedSeatingAllowed', 'guestsSeatingLimit', 'showTimer', 'akumPayment', 'groupSeating', 'hasSms', 'sorting', 'status', 'hasMultipleEvents', 'hide', 'isNotifyByMail',
        // system-written fields — never user edits, only noise in the log
        'meetingIndicator', 'nextMeetingLocation', 'paymentIndicator', 'howMuchWasPaid', 'priceOfferWasSent',
        'presetData', 'printBg', 'stepsDone', 'signaturesCollection', 'gallery', 'files', 'deletedAt', 'tenantId',
        // 'deletedAt' above is the entity property (logged on insert); an update logs the db column name
        'deleted_at', 'pandaId', 'isImportedFromCSV', 'randomValueForFixSearchResults',
        // seating / kiosk (Seatup) side of the event — not part of the CRM history
        'services', 'drinks', 'guests', 'kioskPreset', 'kioskLang', 'presetScreenShot', 'settings', 'lockDate', 'hall', 'preset', 'type',
        // blobs and images — printing them is either huge or meaningless
        'signatures', 'pdfContent', 'previewImage', 'hashForSignatureLink', 'image',
        // foreign keys. Only document.eventClassId is an explicit column (and is resolved to a name);
        // the rest are relation join columns, so both sides read undefined and they never reach the log anyway
        'customerId', 'eventId', 'userId', 'owner', 'admin', 'creator', 'placeId', 'titleId', 'meetingTypeId',
        'planupEventStatusId', 'summaryId', 'termsId', 'customContractId', 'leadSourceId', 'sourceId', 'planupCustomerStatusId',
        // the meeting a new one was set in place of (קבע מחדש) - a link, not an edit
        'rescheduleOfId',
        // the customer's confirmation on the meeting's link - its own log row says it (table 'meetingResponse')
        'customerConfirmedAt', 'customerConfirmedSlot'
    ],


}